import type { PublicState } from '../../shared/protocol';
import { formatClock, formatCountdown } from '../util/format';
import { useServerClock } from '../util/clock';

/** Questions in their veto windows. The hider gets a Veto button (when holding
 *  a Veto); the seeker sees a countdown to resolution. Carries no geometry.
 *  v5.5 §5: a PHOTO question's veto window is phase A of one evolving obligation —
 *  for the hider we label it a *veto window* and pre-announce the capture budget,
 *  so the 0:30 veto countdown isn't mistaken for the photo deadline. */
export function IncomingPanel({ state, onVeto }: { state: PublicState; onVeto: (playId: string) => void }) {
  const now = useServerClock(
    state.timer.serverNow,
    state.pendingPlays.map((p) => p.endsAt),
  );
  const isHider = state.you.role === 'hider';
  const hasVeto = (state.hand ?? []).some((c) => c.kind === 'veto');
  if (state.pendingPlays.length === 0) return null;
  const captureBudget = formatClock(state.settings.photoWindowMs);

  return (
    <div className="incoming">
      {state.pendingPlays.map((p) => {
        const left = Math.max(0, p.endsAt - now());
        const isPhoto = p.family === 'photo';
        return (
          <div className={`incoming__row${isPhoto ? ' incoming__row--photo' : ''}`} key={p.id} data-testid="incoming">
            <div className="incoming__main">
              <span className="incoming__label">{p.label}</span>
              {isHider && isPhoto && (
                <span className="incoming__sub" data-testid="incoming-photo-note">
                  If you don't veto, you'll have {captureBudget} to take the photo
                </span>
              )}
            </div>
            <span className="incoming__count">{formatCountdown(left)}</span>
            {isHider ? (
              <button
                className="btn btn--signal incoming__veto"
                disabled={!hasVeto}
                data-testid={`veto-${p.id}`}
                onClick={() => onVeto(p.id)}
              >
                {hasVeto ? 'Veto' : 'No veto'}
              </button>
            ) : (
              <span className="incoming__await">Incoming</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
